<template>
    <div id="user-app">
        <nav id="user-navigation">
            <router-link class="app-link" to="/app">
                <img src="../../assets/app-icons/navigation/home.svg" alt="Početna" />
                <span>Početna</span>
            </router-link>
            <router-link class="app-link schedule" to="/app/schedule">
                <img src="../../assets/app-icons/navigation/schedule.svg" alt="Raspored" />
                <span>Raspored</span>
                <span v-if="eventCount > 0" class="menu-schedule-number-icon">{{eventCount}}</span>
            </router-link>
            <router-link class="app-link" to="/app/prizes">
                <img src="../../assets/app-icons/navigation/prizes.svg" alt="Nagradna igra" />
                <span>Nagrade</span>
            </router-link>
            <router-link class="app-link" to="/app/map">
                <img src="../../assets/app-icons/navigation/map.svg" alt="Mapa" />
                <span>Mapa</span>
            </router-link>
            <router-link class="app-link" to="/app/fly-talks">
                <img src="../../assets/app-icons/navigation/fly-talks.svg" alt="Fly talks" />
                <span>Fly talks</span>
            </router-link>
        </nav>
        <div class="user-offline" v-if="isOffline">Uređaj je offline. Funkcionalnosti aplikacije su ograničene.<span v-on:click="isOffline = false">X</span></div>
        <router-view />
    </div>
</template>

<script>
    import EventBus from '@/event-bus';

    export default {
        name: 'UserApp',
        data() {
            return {
                appliedEvents: [],
                favoritedEvents: [],
                eventCount: 0,
                isOffline: false
            }
        },
        methods: {
            handleConnection: function() {
                if (navigator.onLine) {
                    this.isReachable(this.$API_URL).then((online) => {
                    if (online) {
                        this.isOffline = false;
                    } else {
                        this.isOffline = true;
                    }
                    });
                } else {
                    this.isOffline = true;
                }
            },
            isReachable: function(url) {
                return fetch(url, { method: 'HEAD', mode: 'no-cors' })
                    .then(function(resp) {
                    return resp && (resp.ok || resp.type === 'opaque');
                    });
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/user/applied-workshops`).then(response => {
                this.appliedEvents = response.data;
                try 
                {
                    let parsedEvents = JSON.parse(localStorage.getItem('favoritedEvents'));
                    this.favoritedEvents = [...parsedEvents];
                } 
                catch 
                {
                    this.favoritedEvents = [];
                }

                this.eventCount = this.appliedEvents.length + this.favoritedEvents.length;
            });
        },
        mounted() {
            EventBus.$on('increment-navigation-number', () => this.eventCount++);
            EventBus.$on('decrement-navigation-number', () => this.eventCount--);
            
            window.addEventListener('online', this.handleConnection);
            window.addEventListener('offline', this.handleConnection);
            this.handleConnection();
        }
    }
</script>

<style>
    * {
        font-family: "Fuse V.2 Display";
    }

    a {
        text-decoration: none;
    }

    body {
        margin: 0;
        padding-bottom: 80px;
        overflow-x: hidden;
    }

    ::-webkit-scrollbar { 
        display: none; 
    }

    #user-navigation {
        display: flex;
        position: fixed;
        justify-content: space-around;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: white;
        box-shadow: 0 -1px 33px 0 rgba(0,0,0,0.1);
        padding: 10px 0;
        z-index: 999;
    }

    .app-link {
        display: flex;
        flex-direction: column;
        flex-basis: 15%;
        align-items: center;
        user-select: none;
    }

    .app-link span {
        font-size: 12px;
        line-height: 12px;
        color: black;
        opacity: 0.6;
    }

    .app-link img {
        width: 20px;
        height: 20px;
        margin-bottom: 10px;
    }

    .app-link.router-link-exact-active img {
        filter: invert(65%) sepia(92%) saturate(358%) hue-rotate(122deg) brightness(92%) contrast(85%);
    }

    .app-link.router-link-exact-active span {
        color: #30cec1;
    }

    #user-navigation .app-link.schedule {
        position: relative;
    }

    #user-navigation .app-link.schedule .menu-schedule-number-icon {
        position: absolute;
        background-color: #30cec1;
        font-size: 10px;
        color: white;
        border-radius: 100%;
        padding: 1px 6px;
        opacity: 1;
        bottom: 16px;
        right: 42%;
    }

    .user-offline {
        position: fixed;
        bottom: 60px;
        padding: 5px 10px;
        background-color: #30cec1;
        color: white;
        font-weight: 700;
        text-align: center;
        z-index: 1000;
    }

    .user-offline span {
        position: absolute;
        right: 5px;
        top: 5px;
        transform: scaleX(1.5);
    }

    @media screen and (max-width: 1250px)
    {
        #user-navigation .app-link.schedule .menu-schedule-number-icon {
            right: 40%;
        }
    }

    @media screen and (max-width: 768px)
    {
        #user-navigation .app-link.schedule .menu-schedule-number-icon {
            right: 35%;
        }
    }

    @media screen and (max-width: 500px)
    {
        #user-navigation .app-link.schedule .menu-schedule-number-icon {
            right: 30%;
        }
    }

    @media screen and (max-width: 380px)
    {
        #user-navigation .app-link.schedule .menu-schedule-number-icon {
            right: 25%;
        }
    }
</style>